import axios from 'axios';
import baseURL from '../../Config';
export async function productsApi(path = '', { method = 'GET', data } = {}) {
    const stored = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
    try {
        const response = await axios({ url: `${baseURL}products${path ? `/${path}` : ''}`, method, data,
            headers: { Authorization: `Bearer ${stored?.data?.token || stored?.data?.accessToken}` } });
        return response.data.data;
    } catch (error) { throw new Error(error.response?.data?.message || 'No se pudo conectar con Productos. Intenta de nuevo.'); }
}
export const money = value => value == null ? '—' : new Intl.NumberFormat('es-PA', { style: 'currency', currency: 'USD' }).format(value / 100);
export const normalized = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
